(function(){
  const el = id => document.getElementById(id);

  const metricBtn = el('metricBtn');
  const imperialBtn = el('imperialBtn');
  const metricBox = el('metricInputs');
  const imperialBox = el('imperialInputs');
  const sex = el('sex');
  const age = el('age');
  const activity = el('activity');
  const heightCm = el('heightCm');
  const weightKg = el('weightKg');
  const heightFt = el('heightFt');
  const heightIn = el('heightIn');
  const weightLb = el('weightLb');

  const bmrOut = el('bmr');
  const tdeeOut = el('tdee');
  const bmiOut = el('bmi');
  const statusOut = el('status');
  const cut250 = el('cut250');
  const cut500 = el('cut500');
  const gain250 = el('gain250');
  const gain500 = el('gain500');
  const resetBtn = el('resetBtn');

  let useMetric = true;

  // Unit toggling
  function setUnits(metric){
    useMetric = metric;
    metricBtn.classList.toggle('active', metric);
    imperialBtn.classList.toggle('active', !metric);
    metricBox.style.display = metric ? '' : 'none';
    imperialBox.style.display = metric ? 'none' : '';
    recalc();
  }

  metricBtn.addEventListener('click', ()=> setUnits(true));
  imperialBtn.addEventListener('click', ()=> setUnits(false));

  // Helpers
  const clamp = (val,min,max)=> Math.min(Math.max(val,min),max);
  function parseNum(v){
    const n = parseFloat(v);
    return isFinite(n) ? n : 0;
  }

  function getInputs(){
    const s = sex.value;
    const a = clamp(parseNum(age.value), 10, 100);
    let cm, kg;

    if (useMetric){
      cm = clamp(parseNum(heightCm.value), 100, 230);
      kg = clamp(parseNum(weightKg.value), 30, 300);
    } else {
      const ft = clamp(parseNum(heightFt.value), 3, 7);
      const inch = clamp(parseNum(heightIn.value), 0, 11);
      const lb = clamp(parseNum(weightLb.value), 66, 650);
      const totalIn = (ft*12) + inch;
      cm = totalIn * 2.54;
      kg = lb * 0.45359237;
    }

    const act = clamp(parseNum(activity.value), 1.1, 2.5);
    return { s, a, cm, kg, act };
  }

  function mifflinStJeor({s,a,cm,kg}){
    // BMR = 10*kg + 6.25*cm - 5*age + C (male +5, female -161)
    const base = 10*kg + 6.25*cm - 5*a + (s==='male' ? 5 : -161);
    return Math.max(800, base);
  }

  function bmiVal(kg, cm){
    const m = cm/100;
    return kg / (m*m);
  }

  function bmiToStatus(bmi){
    // WHO thresholds
    // <18.5 Underweight
    // 18.5–24.9 Normal
    // 25.0–29.9 Overweight
    // 30.0–34.9 Obesity I
    // 35.0–39.9 Obesity II
    // ≥40 Obesity III
    let medical, friendly, cls;
    if (bmi < 18.5){ medical = 'Underweight'; friendly = 'Lean'; cls='warn'; }
    else if (bmi < 25){ medical = 'Normal'; friendly = 'Normal'; cls='good'; }
    else if (bmi < 30){ medical = 'Overweight'; friendly = 'Above Normal'; cls='warn'; }
    else if (bmi < 35){ medical = 'Obesity Class I'; friendly = 'Obese I'; cls='bad'; }
    else if (bmi < 40){ medical = 'Obesity Class II'; friendly = 'Obese II'; cls='bad'; }
    else { medical = 'Obesity Class III'; friendly = 'Obese III'; cls='bad'; }
    return { medical, friendly, cls };
  }

  function format(n){
    return Math.round(n).toLocaleString();
  }

  function recalc(){
    const {s,a,cm,kg,act} = getInputs();
    if (!cm || !kg || !a) return;

    const bmr = mifflinStJeor({s,a,cm,kg});
    const tdee = bmr * act;
    const bmi = bmiVal(kg, cm);

    bmrOut.textContent = format(bmr) + ' kcal/day';
    tdeeOut.textContent = format(tdee) + ' kcal/day';
    bmiOut.textContent = (Math.round(bmi*10)/10).toFixed(1);

    const st = bmiToStatus(bmi);
    statusOut.innerHTML = `<span class="tag ${st.cls}">${st.friendly}</span> <span class="muted">(${st.medical})</span>`;

    // Targets
    cut250.textContent = format(tdee - 250);
    cut500.textContent = format(Math.max(1200, tdee - 500));
    gain250.textContent = format(tdee + 250);
    gain500.textContent = format(tdee + 500);
  }

  ;['change','input'].forEach(evt=>{
    [sex,age,activity,heightCm,weightKg,heightFt,heightIn,weightLb].forEach(el=> el && el.addEventListener(evt, recalc));
  });

  resetBtn.addEventListener('click', ()=>{
    sex.value = 'male'; age.value = 26; activity.value = '1.375';
    heightCm.value = 200; weightKg.value = 90;
    heightFt.value = 6; heightIn.value = 3; weightLb.value = 240;
    setUnits(true);
    recalc();
  });

  // Initialize reasonable imperial defaults from metric values
  function syncImperialFromMetric(){
    const cm = parseNum(heightCm.value)||200;
    const kg = parseNum(weightKg.value)||90;
    const inches = cm / 2.54;
    const ft = Math.floor(inches/12);
    const inch = Math.round(inches - ft*12);
    heightFt.value = ft; heightIn.value = inch;
    weightLb.value = Math.round(kg / 0.45359237);
  }

  syncImperialFromMetric();
  recalc();
})();